import { ETaskPriority, ITask } from "../data_models/task";

export const taskDescriptionMinCharCount = 100;
export const taskDefinitionOfDoneMinCharCount = 50;

export function isTaskTitleValid(title: string): boolean {
    return title.length >= 4 && title.length <= 50;
}

export function isTaskEstimatedHoursValid(estimatedHours: number): boolean {
    return estimatedHours >= 1;
}

export function isTaskDescriptionValid(description: string): boolean {
    return description.length >= taskDescriptionMinCharCount;
}

export function isTaskDefinitionOfDoneValid(definitionOfDone: string): boolean {
    return definitionOfDone.length >= taskDefinitionOfDoneMinCharCount;
}

export function sortByRank(tasks: ITask[]): ITask[] {
    return tasks.sort((a, b) => {
        if (!a.projectRank || !b.projectRank) return 0;
        if (a.projectRank && b.projectRank && a.projectRank > b.projectRank) {
            return -1;
        }
        if (a.projectRank < b.projectRank) {
            return 1;
        }
        return 0;
    });
}   